export function snapshotTiming(raw) {
  return {
    lastSeq: raw.last_seq ?? null,
    startedAt: raw.started_at ?? null,
    finishedAt: raw.finished_at ?? null,
    summary: raw.summary ?? null,
  };
}
